angular.module('angus.filters')
	.filter('absVal', function() {
		return function(val) {
			var out = '';
			if(val)
				return Math.abs(parseFloat(val.toString().replace(/,/g, ''), 10));
			else
				return out;
		};
	});